// @flow
import { useCallback, useState } from 'react';
import uniq from 'lodash/uniq';
import useIntl from '../../hooks/useIntl';
import useCustomEvent from '../../hooks/useCustomEvent';
import { MISSING_TRANSACTION_TYPES_EVENT } from '../../utils/missingTransactionTypesNotice';
import messages from './messages';

const LABELS = {
  PETRENT: messages.petRent,
  SHORTTERM: messages.shortTermLeaseFee,
};

export const useMissingChargesNotice = () => {
  const intl = useIntl();
  const [types, setTypes] = useState<Array<string>>([]);

  const listener = useCallback((e: CustomEvent<Array<string>>) => {
    // One operation can report twice (execute returns both types, and a
    // second save can land before acknowledging), so reports pile into one
    // notice.
    setTypes((current) => uniq([...current, ...e.detail]));
  }, []);
  useCustomEvent({ eventKey: MISSING_TRANSACTION_TYPES_EVENT, listener });

  const acknowledge = useCallback(() => setTypes([]), []);

  const charges = intl.formatList(
    types.map((type) =>
      LABELS[type] ? intl.formatMessage(LABELS[type]) : type,
    ),
    { type: 'conjunction' },
  );

  return { count: types.length, charges, acknowledge };
};
